<template>
  <khrc-navbar/>
  <clinical-research-details-component />
</template>

<script>
import KhrcNavbar from "@/components/KhrcNavbar.vue";
import ClinicalResearchDetailsComponent from "@/components/ClinicalResearchDetailsComponent.vue";

export default {
  components: {
    KhrcNavbar,
    ClinicalResearchDetailsComponent,
  },
};
</script>

<style></style>
